/**
 * Get the ordinal suffix for a number (st, nd, rd, th)
 * @param {number} num - The number to get the ordinal suffix for
 * @returns {string} The ordinal suffix (st, nd, rd, or th)
 */
const getOrdinalSuffix = num => {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) {
        return 'st';
    }
    if (j === 2 && k !== 12) {
        return 'nd';
    }
    if (j === 3 && k !== 13) {
        return 'rd';
    }
    return 'th';
};

export default getOrdinalSuffix;
